import React, { useContext } from "react";
import InputSearchTag from "core/inputs/input-search/InputSearchTag";
import { TAG_TYPES } from "constants/constants";
import { FORM_INFO } from "constants/forms";
import InfoContext from "pages/InfoContext";
import PropTypes from "prop-types";

// Serves both "signed by" and "charged by": same options (branches and
// regions), only the label, the form field and the storage key differ.
const BranchTagField = ({ name, label, selected, stored, setStored, id }) => {
  const { setValue, dashboardFilterOptions } = useContext(InfoContext);

  return (
    <InputSearchTag
      required={false}
      label={label}
      limitChoice={10}
      onDelete={(deleted) => {
        setStored(stored.filter((item) => item.value !== deleted));
        return setValue(
          name,
          selected.filter((item) => item.value !== deleted)
        );
      }}
      options={dashboardFilterOptions}
      popup={FORM_INFO.branchFilter.popup}
      selectedOptions={selected}
      setValue={(newValue) => {
        setStored(newValue);
        return setValue(name, newValue);
      }}
      type={TAG_TYPES.BRANCHES}
      errors={{}}
      id={id}
    />
  );
};

BranchTagField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.object.isRequired,
  selected: PropTypes.array,
  stored: PropTypes.array,
  setStored: PropTypes.func.isRequired,
  id: PropTypes.string,
};

export default BranchTagField;
